import React, {useMemo} from 'react';
import {useQuery} from '@tanstack/react-query';
import app from '@src/helpers/app';
import SoundsSettingItem from '@src/components/_layouts/Default/components/settings/notifications/SoundsSettingItem';
import {FormFieldOption} from '@src/@types/components/Form';
import OrdersListenOnlyTheseStatusesSoundSetting
    from '@src/components/_layouts/Default/components/settings/notifications/OrdersListenOnlyTheseStatusesSoundSetting';
import OrderProductsListenOnlyTheseDepartmentsSoundSetting
    from '@src/components/_layouts/Default/components/settings/notifications/OrderProductsListenOnlyTheseDepartmentsSoundSetting';
import OrderProductsListenOnlyMyDepartmentsSoundSetting
    from '@src/components/_layouts/Default/components/settings/notifications/OrderProductsListenOnlyMyDepartmentsSoundSetting';

export default function OrdersNotificationsSettingsList() {
    const queryKey = useMemo(() => {
        return app('queryKeys').getCustomRequestQueryKey('app-settings-options');
    }, []);
    const {data, error, isFetching} = useQuery<{
        statuses: FormFieldOption[],
        productStatuses: FormFieldOption[],
        departments: FormFieldOption[],
    }, Error>(queryKey, () => {
        return app('http').route('app.get-settings-options');
    });

    return <>
        <SoundsSettingItem
                notificationName="new-order"
                permissionsToDisplay={['users@is-manager', 'manager-dashboard@can-see-dashboard']}
                otherSettings={
                    <OrdersListenOnlyTheseStatusesSoundSetting
                            notificationName="new-order"
                            options={data?.statuses}
                            isLoading={isFetching}
                            error={error}
                    />
                }
        />
        <SoundsSettingItem
                notificationName="new-order-product"
                permissionsToDisplay={[
                    'users@is-manager', 'manager-dashboard@can-see-dashboard',
                    'users@is-production', 'production-dashboard@can-see-dashboard'
                ]}
                otherSettings={<>
                    <OrdersListenOnlyTheseStatusesSoundSetting
                            notificationName="new-order-product"
                            options={data?.productStatuses}
                            isLoading={isFetching}
                            error={error}
                            className="mb-2"
                    />
                    <OrderProductsListenOnlyMyDepartmentsSoundSetting
                            options={data?.departments}
                            isLoading={isFetching}
                            error={error}
                            className="mb-2"
                    />
                    <OrderProductsListenOnlyTheseDepartmentsSoundSetting
                            options={data?.departments}
                            isLoading={isFetching}
                            error={error}
                    />
                </>}
        />
    </>;
}
